import UpdateCartItem from './UpdateCartItem';

export default UpdateCartItem;



// WEBPACK FOOTER //
// ./src/components/shared/UpdateCartItem/index.js